import { Component, OnInit } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, ActionSheetController, AlertController } from 'ionic-angular';
import { NgwGame, NgwTeam, NgwPlayer, NgwRound, NgwPick, NgwScore } from '../../app/classes/NgwGame';
import { NgwService } from '../../app/ngw.service';
import { NgwScorerService } from '../../app/ngwScorer.service';
import { PlayersPage } from '../players/players';
import { Vibration } from '@ionic-native/vibration';
import * as moment from 'moment';

@Component({
  selector: 'page-rounds',
  templateUrl: 'rounds.html'

})
export class Rounds implements OnInit {
  currGame: NgwGame = null;
  currRound: NgwRound = null;
  currRoundNum: String = "1";

  lastRefreshRequest = moment("1/1/2000");

  constructor(public navCtrl: NavController, private vibration: Vibration, public navParams: NavParams, public ngwService: NgwService, public ngwScorerService: NgwScorerService, public loadingController: LoadingController, public actionSheetCtrl: ActionSheetController, public alertCtrl: AlertController) {
  }

  ngOnInit(): void {
    this.currGame = this.ngwService.currentGame;
    if (this.currGame.rounds)
      this.roundChnaged(this.currGame.rounds[this.currGame.rounds.length - 1])
  }

  showPlayer(player: NgwPlayer) {
    return player.removed == false || this.currRound.picks.filter(item => item.ngwPlayer.name == player.name).length > 0;
  }

  getScore() {
    console.log("GetScore")
    let loader = this.loadingController.create({
      content: "Updating Game"
    });
    loader.present();

    console.log(moment().diff(this.lastRefreshRequest, 's'))
    if (moment().diff(this.lastRefreshRequest, 's') < 15) {
      console.log("just fakin it for now")
      window.setTimeout(function () { loader.dismissAll(); }, 1000);
    }
    else {
      this.lastRefreshRequest = moment();
      this.ngwService.getScore(this.currGame.nhlGame).then((score: NgwScore) => {
        this.currGame.currScore = score;
        console.log(score)
        loader.dismissAll();
        if (score.awayScore != this.currRound.startingAwayScore || score.homeScore != this.currRound.startingHomeScore) {
          //make sure the scorer is there 
          if (score.goals.length >= (this.currRound.startingAwayScore + this.currRound.startingHomeScore - 1)) {


            let currGoalScorerId = score.goals[this.currRound.startingAwayScore + this.currRound.startingHomeScore];
            //Go find him
            this.currRound.goalScorer = this.findPlayer(currGoalScorerId);

            if (this.currRound.goalScorer) {
              this.currRound.picks.forEach((pick) => {
                if (pick.nhlPlayer.person.id == currGoalScorerId)
                  this.currRound.winningPick = pick;
              });

              this.vibration.vibrate(300);



              let alert = this.alertCtrl.create({
                title: 'Goal Scored!',
                subTitle: this.currRound.goalScorer.person.fullName + ' scored! Score is now: ' + this.currGame.currScore.awayScore + ' - ' + this.currGame.currScore.homeScore
              });

              if (this.currRound.winningPick) {
                alert.addInput({
                  type: 'radio',
                  label: this.currRound.winningPick.ngwPlayer.name + ' Wins Round',
                  value: 'winningPick',
                  checked: true
                });
              }

              alert.addInput({
                type: 'radio',
                label: 'Cancel Picks, Carry Over Pot',
                value: 'cancelCarry',
                checked: !this.currRound.winningPick
              });

              alert.addInput({
                type: 'radio',
                label: 'Carry Over Picks & Pot',
                value: 'carryCarry',
                checked: false
              });

              alert.addInput({
                type: 'radio',
                label: 'Cancel Picks & Pot',
                value: 'cancelCancel',
                checked: false
              });

              alert.addButton('Cancel');

              alert.addButton({
                text: 'OK',
                handler: data => {

                  if (data == 'winningPick') 
                    this.saveCurrRoundWithWinner(this.currRound.winningPick.ngwPlayer);
                  else if(data == 'cancelCarry')
                    this.saveCurrRoundCancelPicksCarryPot();
                  else if(data == 'carryCarry')
                    this.saveCurrRoundCarryCarry();
                  else if(data == 'cancelCancel')
                    this.saveCurrRoundCancelCancel();
                }
              });

              alert.present();
            }
            console.log("CurrRoundScorer", this.currRound.goalScorer, currGoalScorerId, this.currRound.winningPick)



          }
        }
      })
    }
  }

  showAlert() {

  }

  findPlayer(playerId) {
    let retVal = this.findPlayerByTeam(playerId, this.currGame.away.team.roster.roster);
    if (!retVal)
      retVal = this.findPlayerByTeam(playerId, this.currGame.home.team.roster.roster);

    return retVal;
  }

  findPlayerByTeam(playerId, roster) {
    for (var i = 0; i < roster.length; i++) {
      let player = roster[i];
      if (player.person.id == playerId) {
        return player;
      }
    }

    return null;
  }

  roundChnaged(round: NgwRound) {
    this.currRound = round;
    this.currRoundNum = String(this.currRound.num);
    console.log("CurrRoundNum", round)
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad Rounds');
  }

  makePick(ngwPlayer: NgwPlayer) {
    this.navCtrl.push(PlayersPage, {
      ngwPlayer: ngwPlayer,
      ngwRound: this.currRound
    });
  }

  removePick(ngwPick: NgwPick) {
    this.ngwService.removePick(this.currRound, ngwPick);
  }

  createNextRound() {
    let nextRound: NgwRound = null;
    if (this.currGame.rounds.length > this.currRound.num)
      nextRound = this.currGame.rounds[this.currRound.num];
    else {
      nextRound = this.ngwService.createNewRound(this.currRound.num + 1, this.currRound.carryOverToNextRoundPot, this.currGame.currScore.awayScore, this.currGame.currScore.homeScore);
      this.currGame.rounds.push(nextRound);
    }

    nextRound.totalPot -= nextRound.startingPot;
    nextRound.startingPot = this.currRound.carryOverToNextRoundPot;
    nextRound.totalPot += nextRound.startingPot;

    // this.roundChnaged(nextRound);
  }

  saveCurrRoundWithWinner(player: NgwPlayer) {
    this.ngwScorerService.scoreWithWinner(this.currRound, this.currGame, player);
    this.createNextRound();
    this.ngwService.updateCurrGame();
  }

  saveCurrRoundCarryCarry() {
    this.ngwScorerService.scoreWithNoCarryOverButCarryPicks(this.currRound, this.currGame);
    this.createNextRound();
    var currRoundPicks = this.currGame.rounds[this.currGame.rounds.length - 2].picks;
    var nextRoundPicks = this.currGame.rounds[this.currGame.rounds.length - 1].picks;

    this.currGame.rounds[this.currGame.rounds.length - 1].totalPot = this.currGame.rounds[this.currGame.rounds.length - 2].totalPot;

    currRoundPicks.forEach(pick => nextRoundPicks.push(pick));

    this.ngwService.updateCurrGame();
  }

  saveCurrRoundCancelCancel() {
    this.ngwScorerService.scoreWithNoCarryOver(this.currRound, this.currGame);
    this.createNextRound();
    this.ngwService.updateCurrGame();
  }

  saveCurrRoundCancelPicksCarryPot() {
    this.ngwScorerService.scoreWithCarryOver(this.currRound, this.currGame);
    this.createNextRound();
    this.ngwService.updateCurrGame();
  }

  saveCurrRoundGameOver() {
    this.ngwScorerService.scoreGameOver(this.currRound, this.currGame);
    this.ngwService.updateCurrGame();
  }



  presentActionSheet() {
    let buttons = [];

    if (!this.currRound.isScored) {
      if (this.currRound.winningPick) {
        buttons.push({
          text: this.currRound.winningPick.ngwPlayer.name + ' Wins Round',
          role: 'destructive',
          icon: 'trophy',
          cssClass: ['action-sheet-winner'],
          handler: () => {
            this.saveCurrRoundWithWinner(this.currRound.winningPick.ngwPlayer);
          }
        })
      }

      //Now the ones that'll always be there:
      buttons.push({
        text: 'Cancel Picks, Carry Over Pot',

        icon: 'share-alt',
        handler: () => {
          this.saveCurrRoundCancelPicksCarryPot();

        }
      });

      buttons.push({
        text: 'Carry Over Picks & Pot',

        icon: 'refresh',
        handler: () => {
          this.saveCurrRoundCarryCarry();
        }
      });

      buttons.push({
        text: 'Cancel Picks & Pot',

        icon: 'close-circle',
        handler: () => {
          this.saveCurrRoundCancelCancel();
        }
      });



      buttons.push({
        text: 'Game Over',

        icon: 'time',
        handler: () => {
          this.saveCurrRoundGameOver();

        }
      });



      //now show all the other ppl
      this.currGame.players.forEach((player: NgwPlayer) => {
        if (!this.currRound.winningPick || this.currRound.winningPick.ngwPlayer.name != player.name) {
          buttons.push({
            text: player.name + ' Wins Round',
            icon: 'checkmark-circle',
            handler: () => {
              this.saveCurrRoundWithWinner(player);
            }
          });
        }
      })
    }
    else //is isScored
    {
      if (this.currRound.isScored && (this.currGame.rounds.length <= this.currRound.num || !this.currGame.rounds[this.currRound.num].isScored)) {
        buttons.push({
          text: 'Unscore Round',
          icon: 'undo',
          handler: () => {
            this.ngwScorerService.unScoreRound(this.currRound, this.currGame);
            this.ngwService.updateCurrGame();
          }
        });
      }
    }
    buttons.push({
      text: 'Cancel',
      role: 'cancel',
      handler: () => {
        console.log('Cancel clicked');
      }
    });


    let actionSheet = this.actionSheetCtrl.create({
      title: 'Score Round ' + this.currRound.num,
      buttons: buttons
    });
    actionSheet.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/rounds/rounds.ts